import styled from "styled-components";
import theme from "~/styles/theme";

export const TitleHolder = styled.div`
  padding: 0 16px;
  width: 100%;
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 1005px;
    margin: 0 auto;
  }

  p {
    text-align: center;

    a {
      color: ${theme.palette.neutral.primary.key}
    }
    @media (min-width: ${theme.breakpoints.values.md}px) {
      margin: 0 auto;
      max-width: 839px;
    }
  }

  h5 {
    text-align: center;
  }
`;

export const Warning = styled.div`
  background-color: ${theme.palette.feedback.error.light};
  padding: 24px;
  display: flex;
  margin-top: 32px;
  margin-bottom: 40px;
  border-radius: 32px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-top: 24px;
    margin-bottom: 64px;
  }

  p {
    text-align: left;
    margin-left: 8px;
  }
`;

export const BG = styled.div`
  background-color: #F5F5F5;
`;

export const AlertWrapper = styled.div`
  max-width: 800px;
  margin: 0 auto 16px;
`;

export const TextWrapper = styled.div`
  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin: 0 80px;
  }
`;
